import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_7 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_8 = { class: "dropdown profile-dropdown" }
const _hoisted_9 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = { class: "rounded-1 justify-content-center bg-gray align-items-center d-flex fw-bold fs-18 text-primary text-center w-50 h-50" }
const _hoisted_11 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_12 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_13 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_14 = { class: "dropdown-menu rounded-0 bg-white border-0 start-}}auto end-0" }
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
    'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
    { sticky: _ctx.isSticky },
  ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.fetchAvatar(this.nombre)), 1),
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(this.nombre), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(this.rol), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", {
                  class: "text-body-secondary fw-semibold transition position-relative",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cerrarSesion && _ctx.cerrarSesion(...args)))
                }, [
                  _hoisted_16,
                  _createTextVNode(" Cerrar sesión "),
                  _createVNode(_component_router_link, {
                    to: "/auth",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}